export const colors = {
  primary: '#007541',
  primaryDark: '#025430;',
  primaryLight: '#049B58',
  secondary: ' #FFB000;',
  secondaryLight: 'rgba(255, 176, 0, 0.4)',
  tertiary: '#025430',
  tertiaryDark: '#483B3B',
  quaternary: '#CCC6C6',
  secondaryBackground: '#2c4155',
  cardBack: '#025430',
  secondaryText: '#E83939',
  cardRed: '#ED6060',
  cardBlack: '#443C3C',
  cardWhite: '#ffffff',
  closeStrokeColor: '#3D6389',
  tetriaryBackground: '#38433D',
}
